import { render, staticRenderFns } from "./TwBenchmark.vue?vue&type=template&id=8792a80e&scoped=true"
import script from "./TwBenchmark.vue?vue&type=script&lang=ts"
export * from "./TwBenchmark.vue?vue&type=script&lang=ts"
import style0 from "./TwBenchmark.vue?vue&type=style&index=0&id=8792a80e&prod&lang=scss&scoped=true"
import style1 from "./TwBenchmark.vue?vue&type=style&index=1&id=8792a80e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8792a80e",
  null
  
)

export default component.exports